module.exports = __webpack_public_path__ + "static/img/image05.b6aed61.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image05.png
// module id = VtZt
// module chunks = 0